import axios from 'axios';
import { notFound, redirect } from 'next/navigation';
import { envVariables, ROUTES } from '../utils';

const axiosServerInstance = axios.create({
  baseURL: envVariables.APIURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosServerInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      redirect(ROUTES.HOME);
    }

    // Redirect all other major errors to not-found
    if ([400, 404, 500].includes(status)) {
      notFound();
    }

    return Promise.reject(error);
  },
);

export default axiosServerInstance;
